import { Plugin } from 'ckeditor5';

export default class KeepFontsize extends Plugin {
	init() {
		const editor = this.editor;

    const setDefaultFontSize = () => {
      editor.execute('fontSize', {value: 'default'});
    };

		editor.conversion.for('downcast' ).add( dispatcher => {
			dispatcher.on('remove:$text', (evt, { position }, conversionApi) => {
				if (position.nodeBefore === null) {
					setDefaultFontSize();
				}
			});

      /**
       * This event listener is necessary when several lines
       * e.g. can be marked and deleted by ctrl + a.
       * "remove:$text" above only fires when text within the p tag is deleted.
       * "remove:paragraph" fires across multiple lines or p tags
       */
			dispatcher.on('remove:paragraph', (evt, { position }, conversionApi) => {
				if (position?.nodeBefore === null) {
					setDefaultFontSize();
				}
			});

      dispatcher.on('insert:paragraph', (evt, { item }, conversionApi) => {
				if (item?.name === 'paragraph' && item?._children?._nodes?.length === 0) {
					if (editor.model.document.selection?.anchor?.parent === item) {
						setDefaultFontSize();
					}
				}
			});
		});
	}
}
